import { render } from "./CurrenciesDropdown.vue?vue&type=template&id=797408d3"
import script from "./CurrenciesDropdown.vue?vue&type=script&lang=js"
export * from "./CurrenciesDropdown.vue?vue&type=script&lang=js"

import "./CurrenciesDropdown.vue?vue&type=style&index=0&id=797408d3&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__